import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {Question} from '../../../models/underwriter.model';
import {GlobalQuestionService} from '../../../services/global-question.service';

@Component({
    selector: 'app-vaps-general-four',
    templateUrl: './vaps-general-four.component.html',
    styleUrls: ['./vaps-general-four.component.scss'],
    standalone: false
})
export class VapsGeneralFourComponent implements OnInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: Question;
  @Input() currentVap: QuotePageDataVaps;
  @Input() addAnother: any;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<any>();
  @Output() addAnotherChanged = new EventEmitter<boolean>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();

  vap = {
    description: [],
    session_item_id: '1',
    answer: '',
    price: 0,
  };

  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(0);
      this.vap = null;
      this.getProductDetails();
    }
  }

  getProductDetails(): any {
    if (this.getVapPrice(this.currentVap)) {
      for (const v of this.collation_vaps) {
        if (this.currentVap?.product_vaps_id === v?.product_vaps_id && v?.select === 1) {
          this.vap = {
            description: v?.detail.split('|'),
            session_item_id: v?.session_item_id ? v?.session_item_id : '1',
            answer: v?.detail?.split('|')?.length ? v?.detail.split('|')[1] : '',
            price: v?.premium ? v?.premium : 0,
          };

          if (!this.vap?.answer) {
            this.vap.answer = '';
          }
        }
      }
    } else {
      this.vap = {
        description: [],
        session_item_id: '1',
        answer: '',
        price: 0,
      };
    }
  }

  getVapPrice(v: QuotePageDataVaps): string {
    let price = '';
    for (const c of this.collations) {
      if (v.product_vaps_id === c.vaps_id) {
        price = c.prem_value.toString();
      }
    }
    return price;
  }

  calculate(): void {
    this.onChange(1);
  }

  onChange(action: number): void {
    if (this.vap?.answer) {
      if (action === 1) {
        this.globalQuestionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.vap?.answer;
      this.question.answer = answer;
      this.globalQuestionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, this.vap?.session_item_id, answer, 0, '')
        .subscribe(() => {
          if (action === 1) {
            this.globalQuestionService.resetVaps(true);
            this.globalQuestionService.spinner(false);
          } else {
            this.globalQuestionService.calcPremiumAddons(this.currentVap?.product_vaps_id, this.vap?.session_item_id, this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  p?.forEach(item => {
                    if (this.vap.session_item_id === item?.session_item_id) {
                      this.vap.price = item?.premium;
                    }
                  });
                  this.amountChanged.emit(this.vap?.price);
                  this.globalQuestionService.spinner(false);
                  this.globalQuestionService.resetVaps(false);
                }
              });
          }
        });
    } else {
      this.vap.price = 0;
      this.amountChanged.emit(this.vap?.price);
    }
  }
}
